var _rect, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadgeplayStore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.93,
    height: 42.52,
    viewBox: "0 0 136.93 42.52",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.96,
    y: 1.26,
    width: 135,
    height: 40,
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m130.96,2.06c2.32,0,4.2,1.88,4.2,4.2v30c0,2.32-1.88,4.2-4.2,4.2H5.96c-2.32,0-4.2-1.88-4.2-4.2V6.26c0-2.32,1.88-4.2,4.2-4.2h125m0-.8H5.96C3.21,1.26.96,3.51.96,6.26v30c0,2.75,2.25,5,5,5h125c2.75,0,5-2.25,5-5V6.26c0-2.75-2.25-5-5-5h0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(42 14.26)",
    style: {
      fill: "#fff",
      fontFamily: "ProductSans-Regular, &apos",
      fontSize: "8.38px",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: ".2px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: ".02em"
    }
  }, "GET IT"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 25.13,
    y: 0
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 26.97,
    y: 0,
    style: {
      letterSpacing: ".02em"
    }
  }, "ON")), /*#__PURE__*/React.createElement("path", {
    d: "m69.1,23.01c-2.35,0-4.27,1.79-4.27,4.25s1.92,4.25,4.27,4.25,4.27-1.8,4.27-4.25-1.92-4.25-4.27-4.25Zm0,6.83c-1.29,0-2.4-1.06-2.4-2.58s1.11-2.58,2.4-2.58,2.4,1.05,2.4,2.58-1.11,2.58-2.4,2.58Zm-9.31-6.83c-2.35,0-4.27,1.79-4.27,4.25s1.92,4.25,4.27,4.25,4.27-1.8,4.27-4.25-1.92-4.25-4.27-4.25Zm0,6.83c-1.29,0-2.4-1.06-2.4-2.58s1.11-2.58,2.4-2.58,2.4,1.05,2.4,2.58-1.11,2.58-2.4,2.58Zm-11.08-5.53v1.8h4.32c-.13,1.01-.47,1.76-.98,2.27-.63.63-1.61,1.32-3.33,1.32-2.66,0-4.74-2.14-4.74-4.8s2.08-4.8,4.74-4.8c1.43,0,2.48.56,3.25,1.29l1.27-1.27c-1.08-1.03-2.51-1.82-4.53-1.82-3.64,0-6.7,2.96-6.7,6.61s3.06,6.61,6.7,6.61c1.97,0,3.45-.64,4.61-1.85,1.19-1.19,1.56-2.87,1.56-4.22,0-.42-.03-.81-.1-1.13h-6.07Zm45.31,1.4c-.35-.95-1.43-2.71-3.64-2.71s-4.01,1.72-4.01,4.25c0,2.38,1.8,4.25,4.22,4.25,1.95,0,3.08-1.19,3.54-1.88l-1.45-.97c-.48.71-1.14,1.18-2.09,1.18s-1.63-.43-2.06-1.29l5.69-2.35-.19-.48Zm-5.8,1.42c-.05-1.64,1.27-2.48,2.22-2.48.74,0,1.37.37,1.58.9l-3.8,1.58Zm-4.62,4.12h1.87v-12.5h-1.87v12.5Zm-3.06-7.3h-.06c-.42-.5-1.22-.95-2.24-.95-2.13,0-4.08,1.87-4.08,4.27s1.95,4.24,4.08,4.24c1.01,0,1.82-.45,2.24-.97h.06v.61c0,1.63-.87,2.5-2.27,2.5-1.14,0-1.85-.82-2.14-1.51l-1.63.68c.47,1.13,1.71,2.51,3.77,2.51,2.19,0,4.04-1.29,4.04-4.43v-7.64h-1.77v.69Zm-2.14,5.88c-1.29,0-2.37-1.08-2.37-2.56s1.08-2.59,2.37-2.59,2.27,1.1,2.27,2.59-1,2.56-2.27,2.56Zm24.38-11.08h-4.47v12.5h1.87v-4.74h2.61c2.07,0,4.1-1.5,4.1-3.88s-2.03-3.88-4.1-3.88Zm.05,6.03h-2.65v-4.29h2.65c1.4,0,2.19,1.16,2.19,2.14s-.79,2.14-2.19,2.14Zm11.53-1.8c-1.35,0-2.75.6-3.33,1.91l1.66.69c.35-.69,1.01-.92,1.7-.92.96,0,1.95.58,1.96,1.61v.13c-.34-.19-1.06-.48-1.95-.48-1.79,0-3.6.98-3.6,2.81,0,1.67,1.46,2.75,3.1,2.75,1.25,0,1.95-.56,2.38-1.22h.06v.96h1.8v-4.79c0-2.22-1.66-3.46-3.8-3.46Zm-.23,6.85c-.61,0-1.46-.31-1.46-1.06,0-.96,1.06-1.33,1.98-1.33.82,0,1.21.18,1.7.42-.14,1.16-1.14,1.98-2.22,1.98Zm10.58-6.58l-2.14,5.42h-.06l-2.22-5.42h-2.01l3.33,7.58-1.9,4.21h1.95l5.13-11.79h-2.07Zm-16.81,8h1.87v-12.5h-1.87v12.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.68,20.68l-10.65,11.3s0,0,0,0c.33,1.23,1.45,2.13,2.78,2.13.53,0,1.03-.14,1.46-.4l.03-.02,11.98-6.91-5.61-6.11Z",
    style: {
      fill: "#ea4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.45,18.76h-.01s-5.17-3.01-5.17-3.01l-5.83,5.19,5.85,5.85,5.15-2.97c.9-.49,1.51-1.44,1.51-2.53s-.6-2.04-1.5-2.52Z",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.03,10.54c-.06.24-.1.48-.1.74v19.97c0,.26.03.5.1.74l11.01-11.01-11.01-10.44Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.76,21.26l5.51-5.51-11.97-6.94c-.43-.26-.94-.41-1.49-.41-1.33,0-2.45.91-2.78,2.13,0,0,0,0,0,0l10.73,10.72Z",
    style: {
      fill: "#34a853"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadgeplayStore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/badge.play-store.11e10dc02a518021ddc00a9f2df4386a.svg";